import "./CreditsPage.css"
export default function CreditsPage(){
    return(
        <div className="credits-container">
            <h2>Basic Info</h2>
            <p>This game is a project from <a href="https://www.theodinproject.com/" target="_blank" rel="noreferrer">The Odin Project</a>. The idea is to make a game based on where is Waldo and learn how to work with <a href="https://firebase.google.com/" target="_blank" rel="noreferrer">Firebase</a> as a Baas in a real project</p>
            <h2>Especial Credits</h2>
            <h3>Game image</h3>
            <p>The image used in this game is "The Loc Nar" by Egor Klyuchnyk</p>
            <p>Check his <a href="https://www.instagram.com/ad.2.222/" target="_blank" rel="noreferrer">Instagram</a></p>
            <p>Support him on <a href="https://www.patreon.com/Egor" target="_blank" rel="noreferrer">Patreon</a></p>
            <p>Buy his poster <a href="https://anomaly-world.com/posters-by-anomaly-world/cyberpunk-poster-ad2222" target="_blank" rel="noreferrer">here</a></p>
            <h3>Game Inspiration</h3>
            <p>This game project was heavenly inspired by JCarlosLucio aproach to this same project</p>
            <p>You can check his version of the project <a href="https://lucio-where-is-waldo.netlify.app/" target="_blank" rel="noreferrer">here</a> and his github <a href="https://github.com/JCarlosLucio" target="_blank" rel="noreferrer">here</a></p>
        </div>
    )
}
/*
The Loc Nar by Egor Klyuchnyk
Instagram https://www.instagram.com/ad.2.222/
Patreon https://www.patreon.com/Egor
Buy his poster https://anomaly-world.com/posters-by-anomaly-world/cyberpunk-poster-ad2222
*/